// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__w4MWc","wallet":"navbar_wallet__ybOLn"};